// extracted by mini-css-extract-plugin
export default {"col_1000":"index_col_1000_RcYVD","space31":"index_space31_TPOcB","zkcp_title":"index_zkcp_title_LbgXk"};